import { plato_api_slide_path } from '@/modules/routes';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

interface SlideMascotResponse {
  mascotEnabled?: boolean;
  [key: string]: unknown;
}

export default function useUpdateSlideMascot(slideId: number | string) {
  return useMutation({
    mutationFn: (mascotEnabled: boolean) => (
      axios
        .patch<SlideMascotResponse>(
        plato_api_slide_path(slideId),
        { mascot_enabled: mascotEnabled },
      )
        .then(res => res.data)
    ),
  });
}
